module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('midea-lottie-view', {
    style: _vm.styleConfig_,
    attrs: {
      "data": _vm.lottieData,
      "loop": true
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5bb64bb6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-spinner/index.vue
// module id = 617
// module chunks = 0 1